// Artwork-verified corrections to legacy filename metadata. See docs/portrait-metadata.md.
export default {
  "#4": {
    "url": "#4 Place 3D PeakyNaka.png",
    "from": {
      "background": "PEPLACERESLT"
    },
    "traits": {
      "background": "To The Moon"
    }
  },
  "#25": {
    "url": "#25 CP Jihan KekLordNaka.png",
    "from": {
      "background": "PEPEPARTY"
    },
    "traits": {
      "background": "HOMERPEPE"
    }
  },
  "#107": {
    "url": "#107 Volcano 3D CapNaka.png",
    "from": {
      "naka": "Pepe Cap"
    },
    "traits": {
      "naka": "LORDKEK"
    }
  },
  "#173": {
    "url": "#173 Redputin Jihan CapNaka.png",
    "from": {
      "naka": "Pepe Cap"
    },
    "traits": {
      "naka": "LORDKEK"
    }
  },
  "#198": {
    "url": "#198 Djpepe 3D CapNaka.png",
    "from": {
      "naka": "Pepe Cap"
    },
    "traits": {
      "naka": "LORDKEK"
    }
  },
  "#246": {
    "url": "#246 Basquiat 3D CapNaka.png",
    "from": {
      "naka": "Pepe Cap"
    },
    "traits": {
      "naka": "LORDKEK"
    }
  },
  "#247": {
    "url": "#247 Volcano Keeper HoodedNaka.png",
    "from": {
      "background": "Volcano currency"
    },
    "traits": {
      "background": "PEPEMINING"
    }
  },
  "#263": {
    "url": "#263 Bitcoin Jihan CapNaka.png",
    "from": {
      "naka": "Pepe Cap"
    },
    "traits": {
      "naka": "LORDKEK"
    }
  }
};
